<template>
  <main>
    <b-container>
      <!-- <b-row>
        <b-col md="12" sm="12" class="animated fadeIn">
          <div class="d-flex flex-row justify-content-between">
            <div>
              <h5><strong>Dine Kredittjek</strong></h5>
            </div>
            <div>
              <b-img src="../static/img/dk-registret.png" alt="" width="125" height="42" class="float-right"/>
            </div>
          </div>
          <div class="py-1"></div>
          <table class="table b-table table-striped table-hover">
            <thead>
            <th>CPR</th>
            <th>Navn</th>
            <th class="text-center">Betalingsanmærkning</th>
            <th class="text-center">Info</th>
            </thead>
            <tbody>
            <tr v-for="user in kredit_items"  v-cloak>
              <td>
                <div class="view">
                  {{user.search.CPR}}
                </div>
              </td>
              <td>
                <div class="view">
                  {{user.search.Fornavn}}  {{user.search.Efternavn}}
                </div>
              </td>
              <td class="text-center">
                <div class="view">
                  <span v-if="user.status === 0" class="el-icon-success text-success" style="font-size:18px;"></span>
                  <span v-if="user.status === 1" class="el-icon-error text-danger" style="font-size:18px;"></span>
                </div>
              </td>
              <td class="text-center">
                <div class="edit">
                  <b-btn variant="danger" class="rounded border-0" v-if="user.status === 1" :id="user.id" @click="showDetails(user)">
                    <span class="el-icon-question mr1"></span>
                    Info
                  </b-btn>
                  <b-btn variant="success" class="rounded border-0" v-if="user.status === 0 && user.noresult === 0" @click="showOtherDetails(user)">
                    <span class="el-icon-question mr1"></span>
                    Info
                  </b-btn>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row> -->
      <!-- <b-modal centered lazy v-model="creditShow"  :title="sampleCustomerName" ref="creditModal" class="p-2">
        <div class="modal-content border-0 open-sans">
          <div class="py-2"></div>
          <div class="d-flex flex-row justify-content-start line-height-golden headerfont font-weight-bold">
            <div class="font-weight-bold mr-2">Navn: </div>
            <div class="font-weight-normal">{{ sampleCustomerName }} </div>
          </div>
          <div class="py-2"></div>
          <div class="d-flex flex-row justify-content-start line-height-golden headerfont font-weight-bold">
            <div class="font-weight-bold mr-2">Gender: </div>
            <div class="font-weight-normal">{{ sampleCustomerMale }}</div>
          </div>
          <div class="py-2"></div>
          <div class="d-flex flex-row justify-content-start line-height-golden headerfont font-weight-bold">
            <div class="font-weight-bold mr-2">Addresse: </div>
            <div class="font-weight-normal">{{ sampleCustomerAddresse }}</div>
          </div>
          <div class="py-2"></div>
          <div class="d-flex flex-row justify-content-start line-height-golden headerfont font-weight-bold">
            <div class="font-weight-bold mr-2">Status: </div>
            <div class="font-weight-normal">{{ sampleCustomerStatus }}</div>
          </div>
        </div>
      </b-modal>
      <b-modal centered lazy v-model="creditShowStatus" size="lg" ref="creditModalStatus" class="p-2">
        <div class="modal-content border-0 open-sans">
          <table class="table b-table table-striped table-hover" v-for="item in sampleStatus">
            <thead>
            <th>Navn</th>
            <th class="text-center">Address</th>
            <th class="text-center">Match</th>
            <th class="text-center">Krav Id</th>
            <th class="text-center">Info</th>
            </thead>
            <tbody>
            <tr v-cloak>
              <td>
                <div class="view">
                  {{item.name.firstName}} {{item.name.lastName}}
                </div>
              </td>
              <td class="text-center">
                <div class="view">
                  {{item.address.street}} {{item.address.zip}}
                </div>
              </td>
              <td class="text-center">
                <div class="view">
                  {{item.score}} %
                </div>
              </td>
              <td class="text-center">
                <div class="view">
                  {{item.claimId}}
                </div>
              </td>
              <td class="text-center">
                <div class="edit">
                  <b-btn variant="danger" class="rounded border-0" v-if="checkifclaim(item.claimId)"   @click="checkclaim(item)">
                    <span class="el-icon-question mr1"></span>
                    Tjek dette krav
                  </b-btn>
                </div>
              </td>
            </tr>
            <tr class="table-danger"  v-for="claimItem in returnClaim(item.claimId)"  >
              <td colspan="1">
                Beløb: {{ claimItem.amount }} Kr.
              </td>
              <td colspan="2">
                Notat: {{ claimItem.reasonText }}
              </td>
              <td colspan="2">
                Sidste Dato: {{ moment(String(claimItem.dateOfDeletion)).format('YYYY-MM-DD') }}
              </td>
            </tr>
            </tbody>
          </table>
          <div class="py-4"></div>
        </div>
        <div slot="modal-footer">
          <b-row class="pt-0 pr-2 pb-4 pl-2">
            <b-col>
              <b-btn type="reset" slot="modal-cancel" variant="outline-info" size="lg" @click="closeCreditModal" class="rounded">Luk</b-btn>
            </b-col>
          </b-row>
        </div>
      </b-modal> -->
    </b-container>
  </main>
</template>
<script>
export default {
  name: 'creditcheckList',
  props: ['claimCheck', 'kredit_items', 'claim_items'],
  data () {
    return {
      sampleCustomerName: '',
      sampleCustomerMale: '',
      sampleCustomerAddresse: '',
      id: '',
      sampleCustomerStatus: '',
      // fields: [
      //   {
      //     // A column that needs custom formatting,
      //     // calling formatter 'fullName' in this app
      //     key: 'name',
      //     label: 'Full Name',
      //     formatter: 'fullName'
      //   },
      //   // A regular column
      //   'age',
      //   {
      //     // A regular column with custom formatter
      //     key: 'sex',
      //     formatter: (value) => { return value.charAt(0).toUpperCase() }
      //   },
      //   {
      //     // A virtual column with custom formatter
      //     key: 'birthYear',
      //     label: 'Calculated Birth Year',
      //     formatter: (value, key, item) => {
      //       return (new Date()).getFullYear() - item.age
      //     }
      //   }
      // ],
      sampleCustomer: [],
      sampleStatus: [],
      claimresult: 0,
      claimarray: [],
      creditShow: false,
      creditShowStatus: false
    }
  },
  methods: {
    fullName (value) {
      return `${value.first} ${value.last}`
    },
    checkifclaim (Id) {
      if (this.claim_items[Id]) {
        return false
      } else {
        return true
      }
    },
    returnClaim (Id) {
      if (this.claim_items[Id]) {
        if (this.claim_items[Id].paymentRemarks.paymentRemark.length !== undefined) {
          return this.claim_items[Id].paymentRemarks.paymentRemark
        } else {
          return this.claim_items[Id].paymentRemarks
        }
      } else {
        return []
      }
    },
    showOtherDetails (customer) {
      this.creditShow = !this.creditShow
      this.sampleCustomer = customer
      this.sampleCustomerName = customer.result.personInfoFromCPR.name.firstAndMiddleName + ' ' + customer.result.personInfoFromCPR.name.lastName
      this.sampleCustomerMale = customer.result.personInfoFromCPR.gender
      this.sampleCustomerAddresse = customer.result.personInfoFromCPR.address.standardAddress + ' ' + customer.result.personInfoFromCPR.address.city
      this.sampleCustomerStatus = customer.result.personInfoFromCPR.statusDescription
    },
    showDetails (customer) {
      this.creditShowStatus = !this.creditShowStatus
      console.log(customer.result.debtorPersons.debtorPerson.length)
      if (customer.result.debtorPersons.debtorPerson.length !== undefined) {
        this.sampleStatus = customer.result.debtorPersons.debtorPerson
      } else {
        this.sampleStatus = customer.result.debtorPersons
      }
      this.claimresult = customer.claimresult
      this.id = customer.id
    },
    hideModal () {
      this.$refs.creditModal.hide()
    },
    closeCreditModal () {
      this.$refs.creditModalStatus.hide()
    },
    checkclaim (item) {
      this.$emit('claimCheck', item.claimId, this.id)
      this.$refs.creditModalStatus.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// CreditcheckList.vue?5970a072